import { useTranslation } from '@wix/fe-essentials/i18n';
import { useCallback } from 'react';
import { BiCtaNames, BiModalTypes } from '../../bi/types';
import { useA11yWizardAdapter } from '../../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../../hooks/use-bi-logger';
import { showErrorModal } from './show-error-modal';
export const getHeadingStructureAIErrorModalProps = t => ({
  content: t('accessibility-wizard.heading-structure.ai-error-modal.content'),
  primaryButtonText: t('accessibility-wizard.heading-structure.ai-error-modal.primary-button'),
  secondaryButtonText: t('accessibility-wizard.heading-structure.ai-error-modal.secondary-button'),
  skin: 'destructive',
  title: t('accessibility-wizard.heading-structure.ai-error-modal.title')
});
export const useShowHeadingStructureAIErrorModal = () => {
  const {
    t
  } = useTranslation();
  const biLogger = useBiLogger();
  const {
    a11yWizardAdapter,
    editorHost
  } = useA11yWizardAdapter();
  return useCallback(async _ref => {
    let {
      handleTryAgain,
      handleCancel
    } = _ref;
    const modalType = BiModalTypes.HeadingStructureAiError;
    biLogger.modalView({
      modalType
    });
    await showErrorModal({
      ...getHeadingStructureAIErrorModalProps(t),
      a11yWizardAdapter,
      editorHost,
      onClose: () => {
        biLogger.modalClose({
          modalType
        });
      },
      primaryButtonOnClick: () => {
        biLogger.modalCtaClick({
          ctaName: BiCtaNames.TryAgain,
          modalType
        });
        handleTryAgain();
      },
      secondaryButtonOnClick: () => {
        biLogger.modalCtaClick({
          ctaName: BiCtaNames.Cancel,
          modalType
        });
        handleCancel();
      }
    });
  }, [a11yWizardAdapter, biLogger, editorHost, t]);
};
//# sourceMappingURL=show-heading-structure-ai-error-modal.js.map